export default "__VITE_ASSET__952e7412__"